import { Divider, Table, Pagination, Button } from 'antd'
import { download, GetLocalStorage } from '../../tools/util'
import Style from './taskdetail.module.scss'
import usetaskHooks from './hooks'

// 任务详情
const Taskdetail = () => {
  const { hookstate, onChange, onClickdown } = usetaskHooks()
  const { dataSource, pages, headertitle, file, dataSourceLoading } = hookstate
  const downFile = () => {
    download(`${GetLocalStorage('BASEURL')}${file.fileUrl}`)
  }
  return (
    <div
      className={Style.box}
      style={{ width: '100%', height: '100%', position: 'relative' }}
    >
      <div className={Style.boxlist}>
        <div className={Style.container}>
          <div className={Style.title}>
            <div style={{ float: 'left' }}>
              <div className={Style.titletext}>类型： </div>
              <div style={{ padding: '0 0 0 75px' }}>
                {headertitle.taskResultType}
              </div>
            </div>
            {headertitle.taskResultState === '1' ? (
              <span className={`${Style.icon} ${Style.successicon}`}>成功</span>
            ) : (
              <span className={`${Style.icon} ${Style.erroricon}`}>失败</span>
            )}
            <div style={{ float: 'left' }}>
              <div className={Style.titletext}>
                执行文件：
                <Button type="link" onClick={downFile}>
                  {file.fileName}
                </Button>
              </div>
            </div>
          </div>
          <Divider style={{ margin: '0' }} />
          <div className={Style.title} style={{ whiteSpace: 'pre-line' }}>
            <div className={Style.titletext}>执行结果：</div>
            <div style={{ padding: '0 0 0 75px' }}>
              {/* eslint-disable-next-line */}
              {headertitle.taskResult.replace(/\<br\/>/g, '\n')}
            </div>
          </div>
        </div>
        <div style={{ textAlign: 'right', margin: '0 0 10px 0' }}>
          {headertitle.taskResultState === '1' ? null : (
            <Button type="link" onClick={onClickdown}>
              失败导出
            </Button>
          )}
        </div>
        <Table
          dataSource={dataSource.data}
          loading={dataSourceLoading}
          bordered
          rowKey="sign"
          scroll={{ y: `calc(100vh - ${435}px)` }}
          style={{ height: `calc(100vh - ${435}px)`, borderColor: '#cccccc' }}
          getPopupContainer={() => document.body}
          pagination={false}
        >
          <Table.Column width={300} title="序号" render={(a, b, c) => c + 1} />
          <Table.Column width={300} dataIndex="sign" title="标识" />
          <Table.Column width={300} dataIndex="information" title="执行结果" />
        </Table>
        <Pagination
          style={{ textAlign: 'right', margin: '70px 10px 10px' }}
          showSizeChanger
          showQuickJumper
          pageSizeOptions={['10', '20', '30', '50']}
          total={dataSource.total}
          pageSize={pages.pageSize}
          showTotal={(total) => `共 ${total} 条`}
          current={pages.pageNo}
          size="small"
          onShowSizeChange={(current: number, size: number) =>
            onChange(1, size)
          }
          onChange={(page: number, pageSize?: number) =>
            onChange(page, pageSize)
          }
        />
      </div>
    </div>
  )
}

export default Taskdetail
import { Divider, Table, Pagination, Button } from 'antd'
import { download, GetLocalStorage } from '../../tools/util'
import Style from './taskdetail.module.scss'
import usetaskHooks from './hooks'

// 任务详情
const Taskdetail = () => {
  const { hookstate, onChange, onClickdown } = usetaskHooks()
  const { dataSource, pages, headertitle, file, dataSourceLoading } = hookstate
  const downFile = () => {
    download(`${GetLocalStorage('BASEURL')}${file.fileUrl}`)
  }
  return (
    <div
      className={Style.box}
      style={{ width: '100%', height: '100%', position: 'relative' }}
    >
      <div className={Style.boxlist}>
        <div className={Style.container}>
          <div className={Style.title}>
            <div style={{ float: 'left' }}>
              <div className={Style.titletext}>类型： </div>
              <div style={{ padding: '0 0 0 75px' }}>
                {headertitle.taskResultType}
              </div>
            </div>
            {headertitle.taskResultState === '1' ? (
              <span className={`${Style.icon} ${Style.successicon}`}>成功</span>
            ) : (
              <span className={`${Style.icon} ${Style.erroricon}`}>失败</span>
            )}
            <div style={{ float: 'left' }}>
              <div className={Style.titletext}>
                执行文件：
                <Button type="link" onClick={downFile}>
                  {file.fileName}
                </Button>
              </div>
            </div>
          </div>
          <Divider style={{ margin: '0' }} />
          <div className={Style.title} style={{ whiteSpace: 'pre-line' }}>
            <div className={Style.titletext}>执行结果：</div>
            <div style={{ padding: '0 0 0 75px' }}>
              {/* eslint-disable-next-line */}
              {headertitle.taskResult.replace(/\<br\/>/g, '\n')}
            </div>
          </div>
        </div>
        <div style={{ textAlign: 'right', margin: '0 0 10px 0' }}>
          {headertitle.taskResultState === '1' ? null : (
            <Button type="link" onClick={onClickdown}>
              失败导出
            </Button>
          )}
        </div>
        <Table
          dataSource={dataSource.data}
          loading={dataSourceLoading}
          bordered
          rowKey="sign"
          scroll={{ y: `calc(100vh - ${435}px)` }}
          style={{ height: `calc(100vh - ${435}px)`, borderColor: '#cccccc' }}
          getPopupContainer={() => document.body}
          pagination={false}
        >
          <Table.Column width={300} title="序号" render={(a, b, c) => c + 1} />
          <Table.Column width={300} dataIndex="sign" title="标识" />
          <Table.Column width={300} dataIndex="information" title="执行结果" />
        </Table>
        <Pagination
          style={{ textAlign: 'right', margin: '70px 10px 10px' }}
          showSizeChanger
          showQuickJumper
          pageSizeOptions={['10', '20', '30', '50']}
          total={dataSource.total}
          pageSize={pages.pageSize}
          showTotal={(total) => `共 ${total} 条`}
          current={pages.pageNo}
          size="small"
          onShowSizeChange={(current: number, size: number) =>
            onChange(1, size)
          }
          onChange={(page: number, pageSize?: number) =>
            onChange(page, pageSize)
          }
        />
      </div>
    </div>
  )
}

export default Taskdetail
